import { useObserver } from "mobx-react";
import DashboardHeader from "./dashboardHeader";
import InfoCards from "./InfoCards";
import assesment from "../../assests/assesment.png";
import candidate from "../../assests/candidate.png";
import credit from "../../assests/credit.png";
import BarGraph from "./barGraph";
import Piechart from "./piechart";
import RecentActivity from "./recentActivity";
import TopTalentTable from "./topTalentTable";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useStores } from "../../store";
import { GetMoreCreditsPopUp } from "../dashboard/basicDetails";
import Notification from "../dashboard/Notification";
import PdfViewer from "../reusble_components/pdfViewer";
import { MdClose } from "react-icons/md";
import AssessmentCard from "./assessmentCard";
import ProgressBar from "../reusble_components/profileProgress";
import { AiOutlineClose } from "react-icons/ai";
import { PiSuitcaseSimpleLight } from "react-icons/pi";
import { IoDiamondOutline } from "react-icons/io5";
import { CiWallet } from "react-icons/ci";
import { BsPerson } from "react-icons/bs";
import Piechart2 from "./piechart2";
import { LiaChevronCircleRightSolid } from "react-icons/lia";
import { name } from "../../services/white_label";
export default function Dashboard1() {
  const location = useLocation();
  const [showprogress, setShowProgress] = useState(true);
  const [isAccountVerified, setIsAccountVerified] = useState(false);
  const { RecuiterStore, PopupStore, UserStore } = useStores();
  const navigate = useNavigate();
  const [isopen, setIsopen] = useState(true);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setIsopen(true);
  //   }, 10000);
  //   // return () => clearTimeout(timer);
  // }, []);

  useEffect(() => {
    const isDashboardRoute = location.pathname === "/company/dashboard";
    if (!isDashboardRoute) {
      return;
    }
    const userId = RecuiterStore.getCurrentUserId();
    if (!userId) return;

    RecuiterStore.fetchClientsInfo();
    RecuiterStore.fetchCoinsUsage();
    RecuiterStore.fetchApplicantsData();
    RecuiterStore.fetchRecentActivity();
    RecuiterStore.fetchTopApplicants();

    // Ensure user details are fresh for completion tracking
    UserStore.getUserDetails(true);
  }, [location.pathname, UserStore?.userDetails?._id]);
  const getDataForPiechart = () => {
    const usage = RecuiterStore.coinsUsage || {};
    const data = [
      {
        name: "Resume Analyzer",
        value: usage.resumesUsageamount ?? 0,
        color: "#A78BFA",
      },
      {
        name: "Interviews",
        value: usage.interviewsUsageamount ?? 0,
        color: "#FF805D",
      },
      {
        name: "Job Post",
        value: usage.jobPostUsageAmount ?? 0,
        color: "#FFB82B",
      },
      {
        name: "Mock Tests",
        value: usage.mockTestUsageAmount ?? 0,
        color: "#20BF55",
      },
    ];

    if (
      (usage.resumesUsageamount ?? 0) === 0 &&
      (usage.interviewsUsageamount ?? 0) === 0
    ) {
      data.push({
        name: "No Data",
        value: 1,
        color: "#b0b0b0",
      });
    }

    return data;
  };
  const getProgress = () => {
    // Priority: UserStore (live state) > localStorage (persistence fallback)
    const user =
      UserStore?.userDetails && Object.keys(UserStore.userDetails).length > 0
        ? UserStore.userDetails
        : JSON.parse(localStorage.getItem("user") || "{}");

    if (!user || Object.keys(user).length === 0) return [];

    const basic = user?.address?.length > 0 && user?.mobile;
    const contact = user?.linkedIn?.length > 0;
    const website = user?.websiteURL && user?.pic?.length > 0;

    let data = [
      {
        label: "Basic info",
        completed: basic,
        label2: "Basic info",
        show: true,
      },
    ];

    if (contact && !website) {
      data.push({
        label: "Website info",
        completed: contact,
        label2: "Website info",
        show: true,
      });
      data.push({
        label: "Contact Details",
        completed: website,
        label2: "Contact Details",
        show: true,
      });
    } else if (!contact && website) {
      data.push({
        label: "Website info",
        completed: website,
        show: true,
        label2: "Website info",
      });
      data.push({
        label: "Contact Details",
        completed: contact,
        label2: "Contact Details",
        show: true,
      });
    } else {
      data.push({
        label: "Website info",
        completed: website,
        label2: "Website info",
        show: true,
      });
      data.push({
        label: "Contact Details ",
        completed: contact,
        label2: "Contact Details",
        show: true,
      });
    }
    console.log("Profile Tracking Data:", data);
    return data;
  };

  const completionPercentage = (() => {
    const data = getProgress();
    const totalItems = data.length;
    const completedItems = data.filter((item) => item.completed).length;
    return totalItems > 0 ? (completedItems / totalItems) * 100 : 0;
  })();

  useEffect(() => {
    if (completionPercentage === 100) {
      setShowProgress(false);
    } else {
      setShowProgress(true);
    }
  }, [completionPercentage]);

  const calculateCompletionPercentage = () => {
    return completionPercentage.toFixed(0);
  };

  const addCountToLabelSummaries = (labelSummaries) => {
    let flag = false;
    let data = [];
    data = labelSummaries?.map((label) => {
      const { color, name, ...rest } = label;
      const value = Object.values(rest).reduce((acc, value) => acc + value, 0);
      if (Number(value) === 0 && flag === false) {
        flag = false;
      } else {
        flag = true;
      }

      return { ...label, value };
    });

    return flag
      ? data
      : data?.length > 0
        ? [{ name: "No Data", value: 1, color: "#b0b0b0" }, ...data]
        : [{ name: "No Data", value: 1, color: "#b0b0b0" }];
  };

  // useEffect(() => {
  //   UserStore.getUserDetails().then(() => {
  //     if (!UserStore.userDetails?.isAccountVerified) {
  //       // setIsAccountVerified(true);
  //       navigate("/AccountVerification");
  //     }
  //     console.log(UserStore?.userDetails?.isAccountVerified, "userDetails");
  //   });
  // }, []);

  return useObserver(() => (
    <div>
      {PopupStore.pdfview && (
        <PdfViewer
          pdfUrl={RecuiterStore.pdfLink}
          onClose={() => PopupStore.setPdfView(false)}
        />
      )}

      {PopupStore.getMoreCredits && (
        <GetMoreCreditsPopUp
          popUpInitialValue={PopupStore.getMoreCredits}
          handlePopup={() => {
            PopupStore.setGetMoreCredits(false);
          }}
          referAndEarnHide={true}
        />
      )}
      {PopupStore.notification && (
        <Notification
          popUpInitialValue={PopupStore.notification}
          handlePopup={() => {
            PopupStore.setNotification(false);
          }}
        />
      )}

      {!isopen && (
        <div
          className="bg-primary md:hidden z-50 py-4 px-2 gap-2 w-full h-12 text-center justify-center items-center flex flex-row"
          onClick={() => {
            if (name() !== "Naukritube") {
              navigate("/company/subscription");
            } else {
              navigate("/company/pricing-plans1");
            }
          }}
        >
          <IoDiamondOutline className="text-2xl text-white" />
          <p className="text-xl font-medium text-white">Try Premium</p>
          <LiaChevronCircleRightSolid className="text-white text-2xl" />
        </div>
      )}

      <div className="mt-5 w-[95%] mx-auto">
        <DashboardHeader />
      </div>
      {isopen && (
        <div className="bg-black w-[95%] mx-auto md:hidden flex flex-col relative p-4 my-4 rounded-lg">
          <button
            onClick={() => setIsopen(false)}
            className="absolute -top-2 -right-1 text-white bg-primary  hover:bg-gray-600 rounded-full p-1"
          >
            <MdClose />
          </button>
          {/* <MdClose className="absolute top-2 right-2 text-primary" onClick={() => setIsopen(false)} /> */}
          <div className="  flex flex-row text-center items-center justify-start text-primary gap-3">
            <IoDiamondOutline className="text-primary text-3xl" />
            <p className="text-2xl gil-med">Try Premium</p>
            {/* <MdClose className="absolute top-0 right-0" /> */}
          </div>
          <div>
            <p className="text-gray-100 mt-2">
              Accelerate Your Hiring Process With our AI-driven Smart Hiring
              Co-Pilot, Experience faster, better, and more quality candidate
              screening. Upgrade today and streamline your hiring process!🚀
            </p>
          </div>
          <div>
            <button
              className="bg-primary text-white w-auto text-sm py-2 px-4 rounded-lg mt-4"
              onClick={() => {
                if (name() !== "Naukritube") {
                  navigate("/company/subscription");
                } else {
                  navigate("/company/pricing-plans1");
                }
              }}
            >
              Upgrade to Premium
            </button>
          </div>
        </div>
      )}
      <div className="flex flex-col md:grid mb-12 md:grid-cols-3 gap-4 md:px-8 py-6">
        <span className="col-span-3 mx-3 md:mx-0">
          {showprogress && (
            <ProgressBar
              steps={getProgress()}
              percentage={calculateCompletionPercentage()}
              buttonName="Complete Profile"
              buttonAction={() => {
                navigate("/company/settings");
              }}
              description="Complete your company profile to unlock full functionality and enhance your hiring potential."
              closeIcon={<AiOutlineClose className="text-white text-md " />}
              onClose={() => setShowProgress(false)}
            />
          )}
        </span>
        <span className="col-span-3">
          {RecuiterStore.latestActivityVisible && <AssessmentCard />}
        </span>
        <span className="col-span-3 grid grid-cols-1 md:grid-cols-2 gap-4">
          <InfoCards
            src={assesment}
            count={RecuiterStore.clientsInfo?.assessmentCount ?? 0}
            name="Assessments"
            mcq={RecuiterStore.clientsInfo?.mockTestCount ?? 0}
            tech={RecuiterStore.clientsInfo?.technicalInterviewCount ?? 0}
            hr={RecuiterStore.clientsInfo?.hrInterviewCount ?? 0}
            icon={<PiSuitcaseSimpleLight className="text-black text-3xl" />}
          />
          <InfoCards
            src={candidate}
            count={RecuiterStore.clientsInfo?.totalCandidatesCount ?? 0}
            name="Candidates"
            shortlisted={RecuiterStore.clientsInfo?.isShortlistedCount ?? 0}
            hired={RecuiterStore.clientsInfo?.isHiredCount ?? 0}
            rejected={RecuiterStore.clientsInfo?.isRejectedCount ?? 0}
            icon={<BsPerson className="text-black text-3xl" />}
          />
        </span>
        <BarGraph data={RecuiterStore.applicantsData?.result} />
        <span className="w-[93%] md:w-full mx-auto">
          <Piechart
            w={"w-[50%] ml-0 pl-0 "}
            pl={"pl-12 "}
            data={getDataForPiechart()}
          />
        </span>
        <span className="block md:hidden w-[93%] md:w-full mx-auto">
          <Piechart2
            data={addCountToLabelSummaries(
              RecuiterStore.clientsInfo?.labelSummaries ?? [],
            )}
          />
        </span>
        <RecentActivity />
        <span className="col-span-2 md:h-[40vh] lg:h-[40vh] md:mt-2">
          <TopTalentTable />
        </span>
        <span className="hidden h-[40vh] md:block">
          <Piechart2
            data={addCountToLabelSummaries(
              RecuiterStore.clientsInfo?.labelSummaries ?? [],
            )}
          />
        </span>
        {/* <div className="absolute bottom-0 right-0 mr-4 mb-16 z-50">
          <IoDiamondOutline className="text-orange-400 text-2xl"/>
        </div> */}
      </div>
    </div>
  ));
}
